import { useOrgs } from "./useOrgs";

export const useDemo = () => {
  const { currentOrg } = useOrgs();

  const isDemoOrg = ["Demo_USA", "Demo_Aus"].includes(
    currentOrg?.idString ?? "",
  );

  return {
    isDemoOrg,
  };
};
